// date
export const date = {
  getTimestamp() {
    return +new Date()
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/date.js